export default __webpack_public_path__ + "static/media/avatar-normal-geometric-7.d637fd56.svg";